import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Link,
  Typography,
  Chip
} from '@material-ui/core';

import { RiAlarmWarningFill } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    return value;
  }
}

const printBorder = (a, b) => {
  if (parseInt(a) == parseInt(b)) {
    return 1
  } else {
    return 0
  }
}

const getIconColor = (item) => {
  if (item.rlz == 3) {
    return { color: colors.green[600] }
  } else if (item.sxc || item.hsv || item.dca || item.dia) {
    return { color: colors.yellow[600] }
  } else {
    return { color: colors.red[600] }
  }
}

const getTypeStyle = (ocorrencia) => {
  return { color: 'white', backgroundColor: 'gray' }
}

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment }) => {

  const classes = useStyles();

  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  return (
    <Fragment>

      <TableRow hover key={item.id} className={classes.root}>

        {resultMode.columns.map((col, index) => (
          (index == 0) ? (

            <TableCell>
              <Box
                noWrap={(col.wrap)}
                alignItems="center"
                display="flex"
              >
                <Avatar
                  className={classes.avatar}
                >
                  {<Icon component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
                </Avatar>
                {getFieldValue(col)}
              </Box>
            </TableCell>

          ) : (

            (col.name == 'Ocorrências') ?
              <TableCell>

                {item.ocorrencias.map((ocorrencia, rowIndex) => (
                  <TableRow>
                    <TableCell width={40} noWrap={true} >
                      <Box
                        alignItems="center"
                        display="flex"
                        component={Link}
                        onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(ocorrencia) : {} }}
                      >
                        <Avatar
                          className={classes.avatar}
                        >
                          {<Icon component={RiAlarmWarningFill} style={getIconColor(ocorrencia)} ></Icon>}
                        </Avatar>
                        {ocorrencia.numero}
                      </Box>
                    </TableCell>
                    <TableCell noWrap={true} width={40}><Chip size="small" variant='outlined' style={getTypeStyle(ocorrencia)} label={ocorrencia.tpo} ></Chip></TableCell>
                    <TableCell noWrap={true} width={40}>
                      ABR:.{formatDate(ocorrencia.abr)}<br></br>
                      CPA:.{formatDate(ocorrencia.cpa)}<br></br>
                      CPC:.{formatDate(ocorrencia.cpc)}<br></br>
                      ATD:.{formatDate(ocorrencia.dia)}<br></br>
                      CON:.{formatDate(ocorrencia.dca)}
                    </TableCell>
                    <TableCell noWrap={true} width="100%">{ocorrencia.dsc}</TableCell>
                    <TableCell noWrap={true} width={60}>{ocorrencia.tecnico}</TableCell>
                  </TableRow>
                ))}

              </TableCell>
              :
              <TableCell>

                <Typography variant="body" noWrap={(col.wrap)}  >
                  {getFieldValue(col)}
                </Typography>

              </TableCell>

          )
        ))}


      </TableRow>

    </Fragment >
  );
}

export default Record;